import { Injectable } from '@angular/core';
import { Encounter, EncounterAPIResponse, encounterType } from '../interfaces/encounter';
import { Participant } from '../interfaces/datatypes-fhir';
import { Schedule, ScheduleAPIResponse, scheduleType } from '../interfaces/schedule';

@Injectable({
    providedIn: 'root'
})
export class ScheduleAdapter {

    private extractActor(scheduleAPIResponse: ScheduleAPIResponse, type: string): { name: string, id: string } {
        const actor = scheduleAPIResponse.actor.find(a => a.type === type);
        if (!actor) {
            throw new Error(`Actor of type '${type}' not found.`);
        }
        return { name: actor.display, id: actor.code };
    }

    public adapterToModel(scheduleAPIResponse: ScheduleAPIResponse): Schedule {

        const organization = this.extractActor(scheduleAPIResponse, 'ORGANIZATION');
        const practitioner = this.extractActor(scheduleAPIResponse, 'PRACTITIONER');
        const patient = this.extractActor(scheduleAPIResponse, 'PATIENT');

        //OPCIONAL
        const secretary = scheduleAPIResponse.actor.find(a => a.type === 'SECRETARY');

        return {
            schedule_id: scheduleAPIResponse.schedule_id,
            name: scheduleAPIResponse.name || '',
            type: scheduleAPIResponse.type as scheduleType,
            status: scheduleAPIResponse.status,
            specialty: scheduleAPIResponse.specialty?.[0]?.coding[0].display || undefined,
            servicetype_name: scheduleAPIResponse.serviceType?.[0]?.coding[0].display || undefined,
            servicecategory_name: scheduleAPIResponse.serviceCategory?.[0]?.coding[0].display || undefined,
            organization: { name: organization.name, organization_id: organization.id },
            practitioner: { name: practitioner.name, practitioner_id: practitioner.id },
            patient: { name: patient.name, patient_id: patient.id },
            secretary: secretary ? { name: secretary.display, secretary_id: secretary.code } : undefined,
            startDate: scheduleAPIResponse.planningHorizon?.start || '',
            endDate: scheduleAPIResponse.planningHorizon?.end || '',

        };
    }


    public adaptToAPIFormat(scheduleModel: Schedule): ScheduleAPIResponse {
        const actor = [
            { reference: `practitioners/${scheduleModel.practitioner.practitioner_id}`, code: scheduleModel.practitioner.practitioner_id, display: scheduleModel.practitioner.name, type: 'PRACTITIONER' },
            { reference: `patients/${scheduleModel.patient.patient_id}`, code: scheduleModel.patient.patient_id, display: scheduleModel.patient.name, type: 'PATIENT' },
            { reference: `organizations/${scheduleModel.organization.organization_id}`, code: scheduleModel.organization.organization_id, display: scheduleModel.organization.name, type: 'ORGANIZATION' }
        ];

        if (scheduleModel.secretary) {
            actor.push({
                reference: `secretaries/${scheduleModel.secretary.secretary_id}`,
                code: scheduleModel.secretary.secretary_id,
                display: scheduleModel.secretary.name,
                type: 'SECRETARY'
            });
        }

        return {
            schedule_id: scheduleModel.schedule_id,
            name: scheduleModel.name,
            type: scheduleModel.type,
            status: scheduleModel.status,
            specialty: [{ coding: [{ code: '31', display: scheduleModel.specialty ?? '-' }] }],
            serviceType: [{ coding: [{ code: '221', display: scheduleModel.servicetype_name ?? '-' }] }],
            serviceCategory: [{ coding: [{ code: '31', display: scheduleModel.servicecategory_name ?? '-' }] }],
            actor: actor,
            planningHorizon: {
                start: scheduleModel.startDate || '',
                end: scheduleModel.endDate || ''
            }, 
            active: true
        };
    }



}